import { mapActions, mapGetters, mapMutations } from 'vuex'
import dialogView from './dialog-view/index.vue'
import llmParametersFilter from '../../components/llm-parameters-filter/index.vue'

export default {
    name: 'setting-llm-parameters',
    data () {
        return {
            page: 1,
            showRemoveDialog: false,
            removedItem: null
        }
    },
    components: {
        dialogView,
        llmParametersFilter
    },
    computed: {
        ...mapGetters({
            list: 'settingLlmParameters/list',
            limit: 'settingLlmParameters/limit',
            listLength: 'settingLlmParameters/listLength',
            isLoading: 'settingLlmParameters/isLoading',
            isListLoading: 'settingLlmParameters/isListLoading',
            openDialogView: 'settingLlmParameters/openDialogView'
        }),
        headers () {
            return [
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Name',
                    value: 'name'
                },
                {
                    text: 'Value',
                    value: 'value'
                },
                {
                    text: 'Description',
                    value: 'description'
                },
                {
                    text: 'Actions',
                    sortable: false,
                    value: 'actions'
                }
            ]
        }
    },
    created () {
        this.fetchList()
    },
    methods: {
        ...mapActions({
            fetchList: 'settingLlmParameters/GET_LIST',
            remove: 'settingLlmParameters/DELETE'
        }),
        ...mapMutations({
            changeSkip: 'settingLlmParameters/CHANGE_SKIP',
            changeDialogView: 'settingLlmParameters/CHANGE_DIALOG_VIEW',
            changeEditId: 'settingLlmParameters/CHANGE_EDIT_ID',
            setCurrentItem: 'settingLlmParameters/SET_ITEM'
        }),
        openCreate () {
            this.changeEditId('')
            this.setCurrentItem(null)
            this.changeDialogView(true)
        },
        changeDialog (status = false, item = null) {
            this.changeEditId(item ? item.id : '')
            this.changeDialogView(status)
        },
        changeDialogRemove (item) {
            this.showRemoveDialog = !!item
            this.removedItem = item
        },
        removeListItem () {
            this.remove(this.removedItem).then(() => {
                this.showRemoveDialog = false
                this.$toasted.success(this.$t('success_deleted'))
            })
        }
    }
}
